export const HelpTranslationLinkMap = {
  acquisition: 'app.support_resources.acquisition',
  acquisitionContracts: 'app.support_resources.acquisition_contracts',
  apiGroup: 'app.support_resources.api_group',
  applicationForm: 'app.support_resources.application_form',
  associatingJobsWithRequisitions: 'app.support_resources.associating_jobs_with_requisitions',
  auditLogs: 'app.support_resources.audit_logs',
  autoConfirmationEmail: 'app.support_resources.auto_confirmation_email',
  automatedActions: 'app.support_resources.automated_actions',
  automatedActionsDisqualifyReasons: 'app.support_resources.automated_actions_disqualify_reasons',
  blogDiscoverFeatureUpdate: 'app.support_resources.blog_discover_feature_update',
  blogMobileApp: 'app.support_resources.blog_mobile_app',
  blogPricingUpdate: 'app.support_resources.blog_pricing_update',
  calendar: 'app.support_resources.calendar',
  calendarCollection: 'app.support_resources.calendar_collection',
  calendarConnectionIssues: 'app.support_resources.calendar_connection_issues',
  candidateProgress: 'app.support_resources.candidate_progress',
  careersSite: 'app.support_resources.careers_site',
  careersSiteMigrate: 'app.support_resources.careers_site_migrate',
  careersSiteV2: 'app.support_resources.careers_site_v2',
  configuringRequisitionApprovals: 'app.support_resources.configuring_requisition_approvals',
  connectPipelinesToReports: 'app.support_resources.connect_pipelines_to_reports',
  createEmailSignature: 'app.support_resources.create_email_signature',
  createEvaluationForms: 'app.support_resources.create_evaluation_forms',
  createJobPromotion: 'app.support_resources.create_job_promotion',
  createJobs: 'app.support_resources.create_jobs',
  createTalentPools: 'app.support_resources.create_talent_pools',
  creatingRequisition: 'app.support_resources.creating_requisition',
  csvImporter: 'app.support_resources.csv_importer',
  customDomain: 'app.support_resources.custom_domain',
  defaultJobFields: 'app.support_resources.default_job_fields',
  detailedCandidateEvaluations: 'app.support_resources.detailed_candidate_evaluations',
  disqualifyReasons: 'app.support_resources.disqualify_reasons',
  editCandidateProfile: 'app.support_resources.edit_candidate_profile',
  editJobUrl: 'app.support_resources.edit_job_url',
  eeoCollection: 'app.support_resources.eeo_collection',
  eeoIntro: 'app.support_resources.eeo_intro',
  eeoReporting: 'app.support_resources.eeo_reporting',
  eeoSettingUp: 'app.support_resources.eeo_setting_up',
  emailEmpty: 'app.support_resources.email_empty',
  emailSettings: 'app.support_resources.email_settings',
  enablingRequisitionApprovals: 'app.support_resources.enabling_requisition_approvals',
  evaluationsCollection: 'app.support_resources.evaluations_collection',
  fairEvaluations: 'app.support_resources.fair_evaluations',
  freeJobBoards: 'app.support_resources.free_job_boards',
  freeJobBoardsReposting: 'app.support_resources.free_job_boards_reposting',
  gdprCollection: 'app.support_resources.gdpr_collection',
  gdprConsentAndOtherLinks: 'app.support_resources.gdpr_consent_and_other_links',
  gdprFeaturePack: 'app.support_resources.gdpr_feature_pack',
  gdprManagingCandidatesGdprStatuses:
    'app.support_resources.gdpr_managing_candidates_gdpr_statuses',
  gdprSettingsAutomationsConsentDeleteRequest:
    'app.support_resources.gdpr_settings_automations_consent_delete_request',
  hiringCandidatesFillingJobOpening: 'app.support_resources.hiring_candidates_filling_job_opening',
  integrations: 'app.support_resources.integrations',
  introductionToRequisitionApprovals: 'app.support_resources.introduction_to_requisition_approvals',
  jobBoards: 'app.support_resources.job_boards',
  jobBoardDescription: 'app.support_resources.job_boards',
  jobBreakdown: 'app.support_resources.job_breakdown',
  jobCoverImage: 'app.support_resources.job_cover_image',
  jobDescription: 'app.support_resources.job_description',
  jobFitScore: 'app.support_resources.job_fit_score',
  jobId: 'app.support_resources.job_id',
  jobScheduler: 'app.support_resources.job_scheduler',
  jobSocialMedia: 'app.support_resources.job_social_media',
  jobsMultilang: 'app.support_resources.jobs_multilang',
  jobsPipelines: 'app.support_resources.jobs_pipelines',
  jobsWidget: 'app.support_resources.jobs_widget',
  linkedin: 'app.support_resources.linkedin',
  knockoutQuestions: 'app.support_resources.knockout_questions',
  mailbox: 'app.support_resources.mailbox',
  mailboxConnectionIssues: 'app.support_resources.mailbox_connection_issues',
  mailboxSync: 'app.support_resources.mailbox_sync',
  makeQuickEvaluations: 'app.support_resources.make_quick_evaluations',
  manageLocations: 'app.support_resources.manage_locations',
  manageProfileFields: 'app.support_resources.manage_profile_fields',
  manageTagsAndSources: 'app.support_resources.manage_tags_and_sources',
  manageEvaluations: 'app.support_resources.manage_evaluations',
  manageHiredCandidates: 'app.support_resources.manage_hired_candidates',
  managingMailboxes: 'app.support_resources.managing_mailboxes',
  members: 'app.support_resources.members',
  multilang: 'app.support_resources.multilang',
  multipage: 'app.support_resources.multipage',
  marketplace: 'app.support_resources.marketplace',
  meetingRoms: 'app.settings.meeting_rooms.learn_more_link',
  notificationsPerRole: 'app.support_resources.notifications_per_role',
  organizeByDepartment: 'app.support_resources.organize_by_department',
  overdueCandidates: 'app.support_resources.overdue_candidates',
  pipelineDetails: 'app.support_resources.pipeline_details',
  pipelineSpeed: 'app.support_resources.pipeline_speed',
  pipelineTemplatesBeta: 'app.support_resources.pipeline_templates_beta',
  preventScraping: 'app.support_resources.prevent_scraping',
  proceedDetails: 'app.support_resources.proceed_details',
  profilePrint: 'app.support_resources.profile_print',
  promoteJobs: 'app.support_resources.promote_jobs',
  recentlyDeleted: 'app.support_resources.recently_deleted',
  referralsBeta: 'app.support_resources.referrals_beta',
  referralsBetaCollection: 'app.support_resources.referrals_beta_collection',
  referralsPromotional: 'app.support_resources.referrals_promotional',
  referrerPermissions: 'app.support_resources.referrer_permissions',
  removeIndeedButton: 'app.support_resources.remove_indeed_button',
  reportingAndAnalysis: 'app.support_resources.reporting_and_analysis',
  reportsAndAnalysis: 'app.support_resources.reports_and_analysis',
  reportsBuilder: 'app.support_resources.reports_builder',
  reportsBuilderCandidateOverview: 'app.support_resources.reports_builder_candidate_overview',
  reportsBuilderCustom: 'app.support_resources.reports_builder_custom',
  reportsBuilderDisqualifications: 'app.support_resources.reports_builder_disqualifications',
  reportsBuilderEventsEvaluations: 'app.support_resources.reports_builder_events_evaluations',
  reportsBuilderJobOverview: 'app.support_resources.reports_builder_job_overview',
  reportsBuilderPipelineInsights: 'app.support_resources.reports_builder_pipeline_insights',
  reportsBuilderReportLibrary: 'app.support_resources.reports_builder_report_library',
  reportsBuilderStartFromScratch: 'app.support_resources.reports_builder_start_from_scratch',
  requisitionApprovals: 'app.support_resources.requisition_approvals',
  roles: 'app.support_resources.roles',
  scheduleCandidateInterview: 'app.support_resources.schedule_candidate_interview',
  scheduleEmailsToBeSentLater: 'app.support_resources.schedule_emails_to_be_sent_later',
  scheduleEvaluations: 'app.support_resources.schedule_evaluations',
  scheduleEvents: 'app.support_resources.schedule_events',
  screeningQuestionsTemplates: 'app.support_resources.screening_questions_templates',
  searchWithBoolean: 'app.support_resources.search_with_boolean',
  security: 'app.support_resources.security',
  signInConsent: 'app.support_resources.sign_in_consent',
  sendQuestionnaires: 'app.support_resources.send_questionnaires',
  settingUpTeam: 'app.support_resources.setting_up_team',
  slippingAway: 'app.support_resources.slipping_away',
  sourcingExtension: 'app.support_resources.sourcing_extension',
  ssoOverview: 'app.support_resources.sso_overview',
  syncCalendar: 'app.support_resources.sync_calendar',
  talentPoolId: 'app.support_resources.talent_pool_id',
  talentPools: 'app.support_resources.talent_pools',
  textingCandidate: 'app.support_resources.texting_candidate',
  textingSettings: 'app.support_resources.texting_settings',
  texting10dlc: 'app.support_resources.texting_10dlc',
  timeToDisqualify: 'app.support_resources.time_to_disqualify',
  timeToFill: 'app.support_resources.time_to_fill',
  timeToHire: 'app.support_resources.time_to_hire',
  trackActivities: 'app.support_resources.track_activities',
  trackApplyConversion: 'app.support_resources.track_apply_conversion',
  trackCalendarEventsBreakdown: 'app.support_resources.track_calendar_events_breakdown',
  trackCandidateByMembers: 'app.support_resources.track_candidate_by_members',
  trackCandidateOrigins: 'app.support_resources.track_candidate_origins',
  trackDropOffDetails: 'app.support_resources.track_drop_off_details',
  trackDropoffRate: 'app.support_resources.track_dropoff_rate',
  trackEmailActivity: 'app.support_resources.track_email_activity',
  trackEvaluatedCandidates: 'app.support_resources.track_evaluated_candidates',
  trackEvaluationScore: 'app.support_resources.track_evaluation_score',
  trackJobLifetime: 'app.support_resources.track_job_lifetime',
  trackMembersActivity: 'app.support_resources.track_members_activity',
  trackProceedRate: 'app.support_resources.track_proceed_rate',
  trackTeamMembersTasks: 'app.support_resources.track_team_members_tasks',
  trackTimePerStage: 'app.support_resources.track_time_per_stage',
  trackTimeToEvaluate: 'app.support_resources.track_time_to_evaluate',
  trackTimeToFirstContact: 'app.support_resources.track_time_to_first_contact',
  trialCenter: 'app.support_resources.trial_center',
  thirdPartyIntegration: 'app.support_resources.third_party_integration',
  usingRequisitionApprovalsInTheHiringProcess:
    'app.support_resources.using_requisition_approvals_in_the_hiring_process',
  visibility: 'app.support_resources.visibility',
  webhooks: 'app.support_resources.webhooks',
  workWithEmailTemplates: 'app.support_resources.work_with_email_templates',
  workWithReferrals: 'app.support_resources.work_with_referrals',
  workflowTemplatesBeta: 'app.support_resources.workflow_templates_beta',
  workflowTemplatesCollection: 'app.support_resources.workflow_templates_collection',
  accessToCandidate: 'app.support_resources.access_to_candidate',
  views: 'app.support_resources.views',
};

export type HelpTranslationLinkMapKey = keyof typeof HelpTranslationLinkMap;
